import axios from "axios";
import Cookies from "js-cookie";
import { FIRMFLOWURL } from "../url";

export const getPermissions = () => {
    return new Promise(async (resolve) => {
        try {
            const token = Cookies.get("Bearer");
            const response = await axios.get(`${FIRMFLOWURL}api/admin/permissions`, {
                headers: { Authorization: token },
                    suppressForbiddenToast: true,
            });
            resolve({ ...response, success: true });
        } catch (err) {
            const status = err.response?.status;
            if (status === 401 || err.message.includes("401")) {
                Cookies.remove("Bearer");
                window.location.replace("/");
                resolve({ success: false, status: 401, message: "Please sign in again." });
                return;
            }
            if (status === 403) {
                resolve({ success: false, status, message: "Not authorized" });
                return;
            }
            resolve({
                success: false,
                status,
                message: err.response?.data?.message || err.message,
            });
        }
    });
};
